import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './utils/authContext';
import './styles/App.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-tooltip/dist/react-tooltip.css'


ReactDOM.render(
    <Router>
        <AuthProvider>
           <App />
        </AuthProvider>
    </Router>,
    document.getElementById('root')
);
